import Orders from "../components/profile/Orders";

const OrdersPage = () => {
  return <Orders />;
};

export default OrdersPage;
